export interface Announcement {
  id: string;
  message: string;
  type: 'info' | 'update' | 'warning';
  date?: string;
  linkText?: string;
  linkUrl?: string;
}

const announcements: Announcement[] = [];

export default announcements;
